export default "__VITE_ASSET__BYzGAaPr__"